export const PAYER_CONFIG = {
  name: "Nuxi Dental",
  address: {
    street: "123 Insurance Way",
    city: "Healthcare City",
    state: "HC",
    zip: "12345",
  },
  phone: "(800) 555-0123",
  website: "www.nuxidental.com",
  portalName: "Nuxi Dental",
  supportEmail: "support@nuxidental.com",
};
